import { render, staticRenderFns } from "./testimonial.vue?vue&type=template&id=04f5fedd&lang=html"
import script from "./testimonial.vue?vue&type=script&lang=js"
export * from "./testimonial.vue?vue&type=script&lang=js"
import style0 from "./testimonial.vue?vue&type=style&index=0&id=04f5fedd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports